export async function createWorkoutAggregates(gymStateDb: any, logger: any) {
  logger.info('create workout aggregate views');

  const doc = {
    _id: '_design/workoutSelectionForUser',
    views: {
      businessToolsWorkoutAggregate: {
        map: `function (doc) {
          var isStudioWorkout = doc.gymName.indexOf('Home') === -1;
          if (isStudioWorkout) {
            if (doc.removedAt && !doc.removedReason) {
              emit([doc.memberMainGym, doc.userProfileId, 'totalCancelledStudio', doc.startTime], 1);
            } else if (doc.removedAt && doc.removedReason === 'Cancelled') {
              emit([doc.memberMainGym, doc.userProfileId, 'totalCancelledStudio', doc.startTime], 1);
            } else if (doc.removedAt && doc.removedReason === 'Missed') {
              emit([doc.memberMainGym, doc.userProfileId, 'totalMissedStudio', doc.startTime], 1);
            } else if (!doc.removedAt && doc.checkedIn) {
              emit([doc.memberMainGym, doc.userProfileId, 'totalCompletedStudio', doc.startTime], 1);
              if (doc.workoutType === 15) {
                emit([doc.memberMainGym, doc.userProfileId, 'totalStudio28mins', doc.startTime], 1);
              } else if (doc.workoutType === 25) {
                emit([doc.memberMainGym, doc.userProfileId, 'totalStudio48mins', doc.startTime], 1);
              }
            }
          } else if (!isStudioWorkout)  {
            if (doc.removedAt && doc.removedReason === 'Missed') {
              emit([doc.memberMainGym, doc.userProfileId, 'totalMissedHome', doc.startTime], 1);
            } else if (!doc.removedAt && doc.checkedIn) {
              emit([doc.memberMainGym, doc.userProfileId,'totalCompletedHome', doc.startTime], 1);
              if (doc.workoutType === 6) {
                emit([doc.memberMainGym, doc.userProfileId, 'totalHome17mins', doc.startTime], 1);
              } else if (doc.workoutType === 11) {
                emit([doc.memberMainGym, doc.userProfileId, 'totalHome29mins', doc.startTime], 1);
              } else if (doc.workoutType === 16) {
                emit([doc.memberMainGym, doc.userProfileId, 'totalHome42mins', doc.startTime], 1);
              }
            }
          }

          if (doc.performanceMetrics) {
            if (doc.performanceMetrics.load) {
              emit([
                doc.memberMainGym,
                doc.userProfileId,
                'totalEffortPoints',
                doc.startTime], doc.performanceMetrics.load);
            }

            if (doc.performanceMetrics.calories) {
              emit([
                doc.memberMainGym,
                doc.userProfileId,
                'totalCalories',
                doc.startTime], doc.performanceMetrics.calories);
            }
          }

          if (!doc.removedAt && doc.checkedIn) {
            emit([doc.memberMainGym, doc.userProfileId, 'totalCompleted', doc.startTime], 1);
            if (doc.performanceMetrics) {
              emit([doc.memberMainGym, doc.userProfileId, 'totalHRCompleted', doc.startTime], 1);
            }

            if (doc.settings.ignoreProgramRecommendations) {
              emit([doc.memberMainGym, doc.userProfileId, 'totalCustomisedCompleted', doc.startTime], 1);
            }

            if (doc.settings.cardioOrResistance === 'Cardio') {
              emit([doc.memberMainGym, doc.userProfileId, 'totalBurnCompleted', doc.startTime], 1);
            } else if (doc.settings.cardioOrResistance === 'Balance') {
              emit([doc.memberMainGym, doc.userProfileId, 'totalBalanceCompleted', doc.startTime], 1);
            } else {
              emit([doc.memberMainGym, doc.userProfileId, 'totalBuildCompleted', doc.startTime], 1);
            }

            var startTimeOfFirstExerciseInMs = new Date(doc.startTimeOfFirstExercise).getTime();
            var endTimeOfWorkoutInMs = new Date(doc.endTime).getTime();
            var additionalSecondsBeforeFirstExerciseInMs = ((doc.additionalSecondsBeforeFirstExercise || 0) * 1000);

            var totalMinutes = Math.round(
              (endTimeOfWorkoutInMs - startTimeOfFirstExerciseInMs - additionalSecondsBeforeFirstExerciseInMs) / 60000
            );

            if (totalMinutes > 0) {
              emit([doc.memberMainGym, doc.userProfileId, 'totalDurationInMinutes', doc.startTime], totalMinutes);
            }
          }
        }`,
        reduce: '_sum',
      },
      firstAndLastWorkouts: {
        map: `function (doc) {
            if (!doc.removedAt && doc.checkedIn) {
              var dateAsTime = new Date(doc.startTime).getTime();
              emit(doc.userProfileId, dateAsTime);
            }
        }`,
        reduce: '_stats',
      },
      dateRangeBusinessToolsWorkoutAggregate: {
        map: `function (doc) {
          var isStudioWorkout = doc.gymName.indexOf('Home') === -1;
          if (isStudioWorkout) {
            if (doc.removedAt && !doc.removedReason) {
              emit([doc.memberMainGym, doc.startTime, doc.userProfileId, 'totalCancelledStudio'], 1);
            } else if (doc.removedAt && doc.removedReason === 'Cancelled') {
              emit([doc.memberMainGym, doc.startTime, doc.userProfileId, 'totalCancelledStudio'], 1);
            } else if (doc.removedAt && doc.removedReason === 'Missed') {
              emit([doc.memberMainGym, doc.startTime, doc.userProfileId, 'totalMissedStudio'], 1);
            } else if (!doc.removedAt && doc.checkedIn) {
              emit([doc.memberMainGym, doc.startTime, doc.userProfileId, 'totalCompletedStudio'], 1);
              if (doc.workoutType === 15) {
                emit([doc.memberMainGym, doc.startTime, doc.userProfileId, 'totalStudio28mins'], 1);
              } else if (doc.workoutType === 25) {
                emit([doc.memberMainGym, doc.startTime, doc.userProfileId, 'totalStudio48mins'], 1);
              }
            }
          } else if (!isStudioWorkout)  {
            if (doc.removedAt && doc.removedReason === 'Missed') {
              emit([doc.memberMainGym, doc.startTime, doc.userProfileId, 'totalMissedHome'], 1);
            } else if (!doc.removedAt && doc.checkedIn) {
              emit([doc.memberMainGym, doc.startTime, doc.userProfileId,'totalCompletedHome'], 1);
              if (doc.workoutType === 6) {
                emit([doc.memberMainGym, doc.startTime, doc.userProfileId, 'totalHome17mins'], 1);
              } else if (doc.workoutType === 11) {
                emit([doc.memberMainGym, doc.startTime, doc.userProfileId, 'totalHome29mins'], 1);
              } else if (doc.workoutType === 16) {
                emit([doc.memberMainGym, doc.startTime, doc.userProfileId, 'totalHome42mins'], 1);
              }
            }
          }

          if (doc.performanceMetrics) {
            if (doc.performanceMetrics.load) {
              emit([
                doc.memberMainGym,
                doc.userProfileId,
                'totalEffortPoints',
                doc.startTime], doc.performanceMetrics.load);
            }

            if (doc.performanceMetrics.calories) {
              emit([
                doc.memberMainGym,
                doc.userProfileId,
                'totalCalories',
                doc.startTime], doc.performanceMetrics.calories);
            }
          }

          if (!doc.removedAt && doc.checkedIn) {
            emit([doc.memberMainGym, doc.startTime, doc.userProfileId, 'totalCompleted'], 1);
            if (doc.performanceMetrics) {
              emit([doc.memberMainGym, doc.startTime, doc.userProfileId, 'totalHRCompleted'], 1);
            }

            if (doc.settings.ignoreProgramRecommendations) {
              emit([doc.memberMainGym, doc.startTime, doc.userProfileId, 'totalCustomisedCompleted'], 1);
            }

            if (doc.settings.cardioOrResistance === 'Cardio') {
              emit([doc.memberMainGym, doc.startTime, doc.userProfileId, 'totalBurnCompleted'], 1);
            } else if (doc.settings.cardioOrResistance === 'Balance') {
              emit([doc.memberMainGym, doc.startTime, doc.userProfileId, 'totalBalanceCompleted'], 1);
            } else {
              emit([doc.memberMainGym, doc.startTime, doc.userProfileId, 'totalBuildCompleted'], 1);
            }

            var startTimeOfFirstExerciseInMs = new Date(doc.startTimeOfFirstExercise).getTime();
            var endTimeOfWorkoutInMs = new Date(doc.endTime).getTime();
            var additionalSecondsBeforeFirstExerciseInMs = ((doc.additionalSecondsBeforeFirstExercise || 0) * 1000);

            var totalMinutes = Math.round(
              (endTimeOfWorkoutInMs - startTimeOfFirstExerciseInMs - additionalSecondsBeforeFirstExerciseInMs) / 60000
            );

            if (totalMinutes > 0) {
              emit([doc.memberMainGym, doc.startTime, doc.userProfileId, 'totalDurationInMinutes'], totalMinutes);
            }
          }
        }`,
        reduce: '_sum',
      },
      workoutSelectionForUser: {
        map: `function (doc) {\r\n
          if (doc.removedAt || !doc.workoutSelectionId) {\r\n
            return;\r\n
          }\r\n
          var firstSeperatorIndex = doc.workoutSelectionId.indexOf('_');\r\n
          var workoutSelectionIndex = doc.workoutSelectionId.substring(0, firstSeperatorIndex);\r\n
          var workoutSelectionSettingsKey = doc.workoutSelectionId.substring(firstSeperatorIndex + 1,
           doc.workoutSelectionId.length);\r\n
          emit([doc.userProfileId, workoutSelectionSettingsKey, doc.startTime], +workoutSelectionIndex);\r\n
        }`,
      },
    },
  };

  await gymStateDb.put(doc);
}
